import PT from 'prop-types';

export const FormulaOptionsType = PT.objectOf(PT.arrayOf(PT.shape({
  stat: PT.string.isRequired,
  description: PT.string.isRequired,
  stat_abbr: PT.string.isRequired,
  stat_name: PT.string.isRequired,
  idp: PT.number.isRequired,
  st: PT.number.isRequired,
  id: PT.number.isRequired,
})));

export const FormulaType = PT.shape({
  name: PT.string.isRequired,
  use_st: PT.number.isRequired,
  use_idp: PT.number.isRequired,
  combine: PT.number.isRequired,
  values: PT.objectOf(PT.shape({
    units: PT.number.isRequired,
    points: PT.number.isRequired,
  })),
});



// WEBPACK FOOTER //
// ./src/lib/proptypes/formula.js